<template>
  <div class="w-full h-full absolute bg-black/50 text-center md:py-4">
    <div
      v-if="editableProject && editableProject.id"
      ref="popup"
      class="bg-white md:rounded-lg inline-block md:w-5/6 relative p-4 text-left max-h-full overflow-auto"
      :class="{ 'overflow-hidden': showCancelPopup }"
    >
      <div
        v-if="showCancelPopup"
        class="absolute m-auto top-0 left-0 right-0 bottom-0 bg-black/50 text-center z-10"
      >
        <div class="w-full inline-block md:mt-10 bg-white rounded-lg p-4">
          <span class="font-bold text-2xl">{{ $t('Abbrechen') }}</span><br />
          <div class="text-left mt-4">
            <span
              >{{$t('Sind Sie sicher, dass Sie den Vertrag für {title} ({name}) kündigen möchten?',{title: editableContract.Titel, name: editableContract.Vorname, date: editableContract.cancelDate})}}<br />
              <div v-if="editableContract.cancelCost">
                <span v-if="editableContract.cancelCost == '0 €'"
                  >{{$t('Kostenlose Kündigung')}}</span
                ><span v-else
                  >{{$t('Kündigungskosten: {cost}',{cost: editableContract.cancelCost})}}</span
                >
              </div></span
            >
            <div class="text-center">
              <button @click="showCancelPopup = false" class="mx-2 mt-2">
                {{ $t('Abbrechen') }}
              </button>
              <button @click="cancelContract()" class="mx-2 red">
                {{ $t('Kündigung bestätigen') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showRevokePopup"
        class="absolute m-auto top-0 left-0 right-0 bottom-0 bg-black/50 text-center z-10"
      >
        <div class="w-full inline-block md:mt-10 bg-white rounded-lg p-4">
          <span class="font-bold text-2xl">{{ $t('Vertrag widerrufen') }}</span><br />
          <div class="text-left mt-4">
            <span
              >{{$t('Sind Sie sicher, dass Sie den Vertrag für {title} ({name}) widerrufen möchten?',{title: editableContract.Titel, name: editableContract.Vorname})}}</span
            >
            <div class="text-center">
              <button @click="showRevokePopup = false" class="mx-2 mt-2">
                {{ $t('Abbrechen') }}
              </button>
              <button @click="cancelContract()" class="mx-2 red">
                {{ $t('Widerruf bestätigen') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <span class="text-2xl font-bold mr-2">{{ editableProject.Titel }}</span>
      <span
        v-if="editableContract.Status"
        :class="{
          'text-red-500 px-2 py-1 border-2 border-red-500 rounded': [
            'Gekündigt',
            'Widerrufen',
          ].includes(editableContract.Status),
          'text-green-500 px-2 py-1 border-2 border-green-500 rounded': [
            'Bestätigt',
          ].includes(editableContract.Status),
          'text-yellow-500 px-2 py-1 border-2 border-yellow-500 rounded': [
            'Eingegangen',
            'Warteliste',
            'Kündigung eingegangen',
            'Widerruf eingegangen',
          ].includes(editableContract.Status),
        }"
        >{{ editableContract.Status }}</span
      >
      <font-awesome-icon
        icon="xmark"
        class="text-3xl text-primary cursor-pointer float-right m-3"
        @click="$emit('close')"
      />
      <pre class="whitespace-break-spaces font-sans text-left w-full py-4">{{
        editableProject.Beschreibung
      }}</pre>
      <div
        v-if="editableContract.Dateien && editableContract.Dateien.length > 0"
        class="mb-8"
      >
        <span
          class="font-bold text-xl text-left border-b-primary border-b-2 w-full my-4 inline-block"
          >{{ $t('Dateien') }}<span v-if="editableContract.Dateien && editableContract.Dateien.length > 0"> ({{ editableContract.Dateien.length }})</span></span
        >
        <div v-for="file in editableContract.Dateien" :key="file">
          <a
            :href="frontend + '/files/api/project/' + file.id"
            target="_blank"
            class="border-b border-primary font-bold"
            >{{ file.name }}</a
          >
        </div>
      </div>
      <div class="grid md:grid-cols-2 border-t border-black pt-2">
        <span><b>Start: </b>{{ editableProject.StartDatum }}</span>
        <span class="underline text-xl"
          ><b>Kosten: {{ editableContract.Kosten }}</b></span
        >
        <span
          ><b>{{ $t('Ende') }}: </b
          >{{
            editableProject.EndDatum == null
              ? "Offen"
              : editableProject.EndDatum
          }}</span
        >
        <span v-if="editableContract.SEPAMandatsreferenz"
          ><b>SEPA-Mandatsreferenz: </b
          >{{ editableContract.SEPAMandatsreferenz }}</span
        >
      </div>
      <div class="grid md:grid-cols-2 border-t border-black pt-2">
        <span><b>{{ $t('Adresse:') }} </b></span><br>
        <span>{{editableProject.Ort}}<br>{{editableProject.Strasse}} {{editableProject.Hausnummer}}<br>{{editableProject.PLZ}} {{editableProject.Stadt}}</span>
      </div>
      <div v-if="user.user">
        <span
          class="font-bold text-xl text-left border-b-primary border-b-2 w-full my-4 inline-block"
          >{{ $t('Allgemeine Angaben') }}</span
        >
        <div class="grid md:grid-cols-2">
          <div class="pr-2">
            <label>{{ $t('Vorname Kind:') }}</label>
            <input v-model="editableContract.Vorname" :placeholder="$t('Vorname')" />
          </div>
          <div class="pr-2">
            <label>{{ $t('Nachname Kind:') }}</label>
            <input v-model="editableContract.Nachname" :placeholder="$t('Nachname')" />
          </div>
          <div class="pr-2">
            <label>{{ $t('Geschlecht:') }}</label>
            <select v-model="editableContract.Geschlecht">
              <option value="">{{ $t('Bitte auswählen') }}</option>
              <option value="Männlich">{{ $t('Männlich') }}</option>
              <option value="Weiblich">{{ $t('Weiblich') }}</option>
              <option value="Divers">{{ $t('Divers') }}</option>
            </select>
          </div>
          <div class="pr-2">
            <label>{{ $t('Geburtsdatum:') }}</label>
            <input
              type="date"
              v-model="editableContract.Geburtsdatum"
              :placeholder="$t('Geburtsdatum')"
            />
          </div>
          <div v-if="editableProject.GeburtsortAbfragen" class="pr-2">
            <label>{{ $t('Geburtsort:') }}</label>
            <input
              v-model="editableContract.Geburtsort"
              :placeholder="$t('Geburtsort')"
            />
          </div>
          <div v-if="editableProject.SchulischeAngaben" class="pr-2">
            <label>{{ $t('Klasse:') }}</label>
            <input v-model="editableContract.Klasse" :placeholder="$t('Klasse')" />
          </div>
          <div v-if="editableProject.SchulischeAngaben" class="pr-2">
            <label>{{ $t('Schuljahr:') }}</label>
            <input v-model="editableContract.Schuljahr" :placeholder="$t('Schuljahr')" />
          </div>
          <div v-if="editableProject.AusweisAbfragen" class="pr-2">
            <label>{{ $t('Ausweistyp:') }}*</label>
            <select v-model="editableContract.Ausweistyp">
              <option value="">{{ $t('Bitte auswählen') }}</option>
              <option value="Personalausweis">{{ $t('Personalausweis') }}</option>
              <option value="Reisepass">{{ $t('Reisepass') }}</option>
              <option value="Sonstiges">{{ $t('Sonstiges') }}</option>
            </select>
          </div>
          <div v-if="editableProject.AusweisAbfragen" class="pr-2">
            <label>{{ $t('Nationalität:') }}*</label>
            <input v-model="editableContract.Nationalitaet" :placeholder="$t('Nationalität')" />
          </div>
          <div v-if="editableProject.AusweisAbfragen" class="pr-2">
            <label>{{ $t('Ausweisnummer:') }}*</label>
            <input v-model="editableContract.Ausweisnr" :placeholder="$t('Ausweisnummer')" />
          </div>
          <div v-if="editableProject.AusweisAbfragen" class="pr-2">
            <label>{{ $t('Ausweis gültig bis:') }}</label>
            <input type="date" v-model="editableContract.AusweisGueltigBis" :placeholder="$t('Gültig bis')" />
          </div>
          <div class="pr-2">
            <input
              id="Geschwisterkind"
              type="checkbox"
              v-model="editableContract.Geschwisterkind"
              placeholder="{{ $t('Geschwisterkind') }}"
            />
            <label for="Geschwisterkind">{{ $t('Geschwisterkind') }}</label>
          </div>
          <div v-if="editableProject.BehinderungAbfragen" class="pr-2">
            <input
              id="Behinderung"
              type="checkbox"
              v-model="editableContract.Behinderung"
              placeholder="{{ $t('Behinderung') }}"
            />
            <label for="Behinderung">{{ $t('Behinderung') }}</label>
          </div>
          <div v-if="editableProject.AbholungNotwendigAbfragen" class="pr-2">
            <input
              id="AbholungNotwendig"
              type="checkbox"
              v-model="editableContract.AbholungNotwendig"
              :placeholder="$t('Kind muss persönlich abgeholt werden')"
            />
            <label for="AbholungNotwendig">{{ $t('Kind muss persönlich abgeholt werden') }}</label>
          </div>
          <div
            v-if="
              editableProject.Betreuungsendeoptionen &&
              editableProject.Betreuungsendeoptionen.split(',').length > 1
            "
            class="pr-2"
          >
            <label>{{ $t('Betreuungsende') }}</label>
            <select v-model="editableContract.Betreuungsende">
              <option
                :value="option"
                v-for="option in editableProject.Betreuungsendeoptionen.split(
                  ','
                )"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
          </div>
          <div class="pr-2">
            <label>{{ $t('Bemerkung:') }}</label>
            <input
              v-model="editableContract.Bemerkung"
              :placeholder="$t('Bemerkung')"
            />
          </div>
          <div class="pr-2" v-if="editableProject.FreifeldAnzeigen">
            <label>{{ editableProject.FreifeldTitel }}</label>
            <select v-model="editableContract.Freifeld" class="border-b border-black">
              <option v-if="editableProject.Freifeldoption1" :value="editableProject.Freifeldoption1">{{ editableProject.Freifeldoption1 }}</option>
              <option v-if="editableProject.Freifeldoption2" :value="editableProject.Freifeldoption2">{{ editableProject.Freifeldoption2 }}</option>
              <option v-if="editableProject.Freifeldoption3" :value="editableProject.Freifeldoption3">{{ editableProject.Freifeldoption3 }}</option>
              <option v-if="editableProject.Freifeldoption4" :value="editableProject.Freifeldoption4">{{ editableProject.Freifeldoption4 }}</option>
              <option v-if="editableProject.Freifeldoption5" :value="editableProject.Freifeldoption5">{{ editableProject.Freifeldoption5 }}</option>
            </select>
          </div>
        </div>

        <div
          v-if="editableProject.Preisauswahl && !editableProject.Tagesauswahl"
        >
          <span
            class="font-bold text-xl text-left border-b-primary border-b-2 w-full my-4 inline-block"
            >{{ $t('Kosten') }}</span
          >
          <div v-if="editableProject.Preisauswahl1">
            <input
              id="Preisauswahl1"
              name="Kosten"
              v-model="editableContract.Kosten"
              type="radio"
              :value="editableProject.Preisauswahl1"
            /><label for="Preisauswahl1">{{
              editableProject.Preisauswahl1
            }}</label>
          </div>
          <div v-if="editableProject.Preisauswahl2">
            <input
              id="Preisauswahl2"
              name="Kosten"
              v-model="editableContract.Kosten"
              type="radio"
              :value="editableProject.Preisauswahl2"
            /><label for="Preisauswahl2">{{
              editableProject.Preisauswahl2
            }}</label>
          </div>
          <div v-if="editableProject.Preisauswahl3">
            <input
              id="Preisauswahl3"
              name="Kosten"
              v-model="editableContract.Kosten"
              type="radio"
              :value="editableProject.Preisauswahl3"
            /><label for="Preisauswahl3">{{
              editableProject.Preisauswahl3
            }}</label>
          </div>
          <div v-if="editableProject.Preisauswahl4">
            <input
              id="Preisauswahl4"
              name="Kosten"
              v-model="editableContract.Kosten"
              type="radio"
              :value="editableProject.Preisauswahl4"
            /><label for="Preisauswahl4">{{
              editableProject.Preisauswahl4
            }}</label>
          </div>
          <div v-if="editableProject.Preisauswahl5">
            <input
              id="Preisauswahl5"
              name="Kosten"
              v-model="editableContract.Kosten"
              type="radio"
              :value="editableProject.Preisauswahl5"
            /><label for="Preisauswahl5">{{
              editableProject.Preisauswahl5
            }}</label>
          </div>
        </div>
        <div v-if="editableProject.Tagesauswahl">
          <div
            class="text-left border-b-primary border-b-2 w-full my-4 inline-block"
          >
            <span class="font-bold text-xl mr-4 inline-block mb-2"
              >{{ $t('Tagesauswahl') }}</span
            ><button
              v-if="
                editableProject.TageAenderbar &&
                editableContract.Status == 'Bestätigt'
              "
              @click="changeDayFields = !changeDayFields"
            >
              {{ $t('Tage anpassen') }}
            </button>
          </div>
          <div v-if="changeDayFields">
            <span class="font-bold text-lg block">{{ $t('Tage anpassen') }}</span>
            <span
              >{{$t('Nachfolgend können Sie die Auswahl der Wochentage für Ihren Vertrag selber anpassen: Eine Aufstockung der Tage ist bis zu 5 Tage/Woche möglich, eine Reduzierung – basierend auf die aktuell gebuchte Anzahl – nur bis auf ein Minimum von {minDates} Tag/en. Nächstmögliches Startdatum für die gewünschte Änderung ist der {date}.',{date: earliestChangeDate.toLocaleDateString(), minDates: editableContract.InitialeAnzahlTage - 1})}}</span
            >
            <label class="block">{{ $t('Änderungen gültig ab:') }}</label>
            <input
              type="month"
              v-model="editableContract.AenderungTage"
              :min="earliestChangeDate.toISOString().substring(0, 7)"
              id="changeDays"
              class="w-1/2"
            />
            <span class="font-bold text block mt-4">{{ $t('Neue Auswahl der Wochentage') }}</span>
            <div class="grid md:grid-cols-2">
              <div class="pr-2">
                <input
                  id="AenderungMontag"
                  type="checkbox"
                  @change="calculateCost(true)"
                  v-model="editableContract.AenderungMontag"
                  placeholder="Montag"
                />
                <label for="AenderungMontag">{{ $t('Montag') }}</label>
              </div>
              <div class="pr-2" v-if="!editableProject.DienstagAusblenden">
                <input
                  id="AenderungDienstag"
                  type="checkbox"
                  @change="calculateCost(true)"
                  v-model="editableContract.AenderungDienstag"
                  placeholder="Dienstag"
                />
                <label for="AenderungDienstag">{{ $t('Dienstag') }}</label>
              </div>
              <div class="pr-2">
                <input
                  id="AenderungMittwoch"
                  type="checkbox"
                  @change="calculateCost(true)"
                  v-model="editableContract.AenderungMittwoch"
                  placeholder="Mittwoch"
                />
                <label for="AenderungMittwoch">{{ $t('Mittwoch') }}</label>
              </div>
              <div class="pr-2">
                <input
                  id="AenderungDonnerstag"
                  type="checkbox"
                  @change="calculateCost(true)"
                  v-model="editableContract.AenderungDonnerstag"
                  placeholder="Donnerstag"
                />
                <label for="AenderungDonnerstag">{{ $t('Donnerstag') }}</label>
              </div>
              <div class="pr-2" v-if="!editableProject.FreitagAusblenden">
                <input
                  id="AenderungFreitag"
                  type="checkbox"
                  @change="calculateCost(true)"
                  v-model="editableContract.AenderungFreitag"
                  placeholder="Freitag"
                />
                <label for="AenderungFreitag">{{ $t('Freitag') }}</label>
              </div>
            </div>
            <span class="font-bold text block mt-4">{{ $t('Bisherige Auswahl der Wochentage') }}</span>
          </div>
          <div class="grid md:grid-cols-2">
            <div class="pr-2">
              <input
                id="Montag"
                type="checkbox"
                @change="calculateCost()"
                v-model="editableContract.Montag"
                placeholder="Montag"
              />
              <label for="Montag">{{ $t('Montag') }}</label>
            </div>
            <div class="pr-2" v-if="!editableProject.DienstagAusblenden">
              <input
                id="Dienstag"
                type="checkbox"
                @change="calculateCost()"
                v-model="editableContract.Dienstag"
                placeholder="Dienstag"
              />
              <label for="Dienstag">{{ $t('Dienstag') }}</label>
            </div>
            <div class="pr-2">
              <input
                id="Mittwoch"
                type="checkbox"
                @change="calculateCost()"
                v-model="editableContract.Mittwoch"
                placeholder="Mittwoch"
              />
              <label for="Mittwoch">{{ $t('Mittwoch') }}</label>
            </div>
            <div class="pr-2">
              <input
                id="Donnerstag"
                type="checkbox"
                @change="calculateCost()"
                v-model="editableContract.Donnerstag"
                placeholder="Donnerstag"
              />
              <label for="Donnerstag">{{ $t('Donnerstag') }}</label>
            </div>
            <div class="pr-2" v-if="!editableProject.FreitagAusblenden">
              <input
                id="Freitag"
                type="checkbox"
                @change="calculateCost()"
                v-model="editableContract.Freitag"
                placeholder="Freitag"
              />
              <label for="Freitag">{{ $t('Freitag') }}</label>
            </div>
          </div>
          <div class="grid md:grid-cols-2 mt-4" v-if="changeDayFields">
            <span class="font-bold text block"
              >{{$t('Bisherige Kosten: {cost}',{cost: editableContract.Kosten})}}</span
            >
            <span class="font-bold text block"
              >{{$t('Neue Kosten: {cost}',{cost: editableContract.KostenNeu})}}</span
            >
          </div>
          <div class="mt-4 text-center" v-if="changeDayFields">
            <button
              :class="
                days >= editableContract.InitialeAnzahlTage - 1 &&
                editableContract.AenderungTage
                  ? 'full-red'
                  : 'full-gray'
              "
              @click="changeDays"
            >
              {{ $t('Vertrag kostenpflichtig ändern') }}
            </button>
          </div>
        </div>
        <div v-if="editableProject.Essensangaben">
          <span
            class="font-bold text-xl text-left border-b-primary border-b-2 w-full my-4 inline-block"
            >{{ $t('Essensangaben') }}</span
          >
          <div class="grid md:grid-cols-2">
            <div class="pr-2">
              <input
                id="Vegetarisch"
                type="checkbox"
                v-model="editableContract.Vegetarisch"
                placeholder="Vegetarisch"
              />
              <label for="Vegetarisch">{{ $t('Vegetarisch') }}</label>
            </div>
            <div class="pr-2">
              <input
                id="Schweinefleischfrei"
                type="checkbox"
                v-model="editableContract.Schweinefleischfrei"
                placeholder="Schweinefleischfrei"
              />
              <label for="Schweinefleischfrei">{{ $t('Schweinefleischfrei') }}</label>
            </div>
            <div class="pr-2">
              <input
                id="Laktosefrei"
                type="checkbox"
                v-model="editableContract.Laktosefrei"
                placeholder="Laktosefrei"
              />
              <label for="Laktosefrei">{{ $t('Laktosefrei') }}</label>
            </div>
            <div class="pr-2">
              <input
                id="Zöliakie"
                type="checkbox"
                v-model="editableContract.Zoeliakie"
                placeholder="Zöliakie"
              />
              <label for="Zöliakie">{{ $t('Zöliakie') }}</label>
            </div>
            <div class="pr-2">
              <input
                id="Nussallergie"
                type="checkbox"
                v-model="editableContract.Nussallergie"
                placeholder="Nussallergie"
              />
              <label for="Nussallergie">{{ $t('Nussallergie') }}</label>
            </div>
          </div>
          <div
            v-if="
              editableContract.Zoeliakie ||
              editableContract.Nussallergie ||
              editableContract.Laktosefrei
            "
          >
            <label>{{ $t('Nachweisdokument') }}</label>
            <input type="file" @change="handleFileChange($event, 'allergy')" v-if="!editableContract.AllergieNachreichen"/>
            <div>
              <input
                id="AllergieNachreichen"
                name="AllergieNachreichen"
                v-model="editableContract.AllergieNachreichen"
                type="checkbox"
              /><label for="AllergieNachreichen" class="mt-4 inline-block">{{ $t('Später nachreichen') }}</label>
            </div>
          </div>
        </div>
        <div v-if="editableProject.BUTAbfrage">
          <span
            class="font-bold text-xl text-left border-b-primary border-b-2 w-full my-4 inline-block"
            >{{ $t('Förderung') }}</span
          >
          <div class="">
            <div class="pr-2">
              <input
                id="BuT-berechtigt"
                type="checkbox"
                @change="changePriceForBut()"
                v-model="editableContract.BUTBerechtigt"
                placeholder="BuT-berechtigt"
              />
              <label for="BuT-berechtigt">{{ $t('BuT-berechtigt') }}</label>
            </div>
            <div
              v-if="
                editableContract.BUTBerechtigt && editableProject.BUTAuswahl
              "
              class="pr-2"
            >
              <span
                >{{ $t('Sie haben Anspruch aus Leistungen für Bildung und Teilhabe. Bitte wählen sie ihre Leistungsart aus. Im Anschluss können sie die AKTUELLEN Bescheide hochladen (dies ist auch innerhalb von 14 Tagen nach Vertragsabschluss im Anmeldebereich möglich). Sie können die Unterlagen auch an : ev-angel-isch gGmbH, Venloer Str. 1055, 50289 Köln binnen 14 Tage nach Vertragsabschluss per Post schicken. Sollte unsere Prüfung ergeben, dass sie keinen Anspruch auf Leistungen aus Bildung und Teilhabe haben, fallen die angezeigten Kosten pro Monat an. Sollten Sie hierzu Fragen haben oder Unterstützung benötigen rufen sie uns unter 0221-16959590 an. Gerne helfen ihnen auch der Schulsozialarbeiter und unsere Ansprechpartner vor Ort).') }}</span
              ><br />
              <label>{{ $t('Leistungsart') }}</label><br />
              <input
                id="Leistungsbescheid Jobcenter"
                name="BUTArt"
                type="radio"
                v-model="editableContract.BUTArt"
                value="Leistungsbescheid Jobcenter"
              /><label for="Leistungsbescheid Jobcenter">{{ $t('Leistungsbescheid Jobcenter') }}</label><br />
              <input
                id="Wohngeldbescheid"
                name="BUTArt"
                v-model="editableContract.BUTArt"
                type="radio"
                value="Wohngeldbescheid"
              /><label for="Wohngeldbescheid">{{ $t('Wohngeldbescheid') }}</label><br />
              <input
                id="Kinderzuschlag"
                name="BUTArt"
                v-model="editableContract.BUTArt"
                type="radio"
                value="Kinderzuschlag"
              /><label for="Kinderzuschlag">{{ $t('Kinderzuschlag') }}</label><br />
              <input
                id="Leistungsbescheid nach dem Asylbewerbergesetz"
                name="BUTArt"
                v-model="editableContract.BUTArt"
                type="radio"
                value="Leistungsbescheid nach dem Asylbewerbergesetz"
              /><label for="Leistungsbescheid nach dem Asylbewerbergesetz">{{ $t('Leistungsbescheid nach dem Asylbewerbergesetz') }}</label><br />
              <label>{{ $t('Nachweisdokument') }}</label>
              <input type="file" @change="handleFileChange($event, 'but')" v-if="!editableContract.BUTNachreichen"/>
              <div>
              <input
                id="BUTNachreichen"
                name="BUTArt"
                v-model="editableContract.BUTNachreichen"
                type="checkbox"
              /><label for="BUTNachreichen" class="mt-4 inline-block">{{ $t('Später nachreichen') }}</label></div>
            </div>
            <div v-else-if="editableContract.BUT" class="pr-2">
              <span
                >{{ $t('Sie haben Anspruch aus Leistungen für Bildung und Teilhabe. Bitte wählen sie ihre Leistungsart aus. Im Anschluss können sie die AKTUELLEN Bescheide hochladen (dies ist auch innerhalb von 14 Tagen nach Vertragsabschluss im Anmeldebereich möglich). Sie können die Unterlagen auch an : ev-angel-isch gGmbH, Venloer Str. 1055, 50289 Köln binnen 14 Tage nach Vertragsabschluss per Post schicken. Sollte unsere Prüfung ergeben, dass sie keinen Anspruch auf Leistungen aus Bildung und Teilhabe haben, fallen die angezeigten Kosten pro Monat an. Sollten Sie hierzu Fragen haben oder Unterstützung benötigen rufen sie uns unter 0221-16959590 an. Gerne helfen ihnen auch der Schulsozialarbeiter und unsere Ansprechpartner vor Ort).') }} Sie haben Anspruch aus Leistungen für Bildung und Teilhabe, weil sie einen Leistungsbescheid vom Jobcenter haben, Wohngeld beziehen oder einen Kinderzuschlag bekommen. Nach Vertragabschluss bekommen Sie alle auszufüllenden Unterlagen und Infos per Mail zugesandt. Sollte unsere Prüfung ergeben, dass sie keinen Anspruch auf Leistungen aus Bildung und Teilhabe haben, fallen angezeigten Kosten pro Monat an.</span
              >
            </div>
          </div>
        </div>
        <div v-if="editableProject.UploadDokument1">
          <span
            class="font-bold text-xl text-left border-b-primary border-b-2 w-full my-4 inline-block"
            >{{ $t('Nachweisdokument') }}</span
          >
          <div class="">
            <div>
              <label>{{ $t('Dokumententyp') }}</label><br />
              <template v-for="docId in ['1', '2', '3', '4', '5']" :key="docId">
                <input
                  v-if="editableProject['UploadDokument' + docId]"
                  :id="'UploadDoc' + docId"
                  name="BUTArt"
                  type="radio"
                  v-model="editableContract.uploadDocumentType"
                  :value="editableProject['UploadDokument' + docId]"
                /><label :for="'UploadDoc' + docId" class="block">{{
                  editableProject["UploadDokument" + docId]
                }}</label></template
              >
              <input
                v-if="editableContract.uploadDocumentType"
                type="file"
                @change="handleFileChange($event, 'upload')"
              />
            </div>
          </div>
        </div>
        <span
          class="font-bold text-xl text-left border-b-primary border-b-2 w-full my-4 inline-block"
          >{{ $t('Rechtliches') }}</span
        >
        <div class="">
          <div class="pr-2">
            <input
              id="AGB"
              type="checkbox"
              v-model="editableContract.AGB"
              placeholder="AGB"
            />
            <label for="AGB">{{ $t('*Hiermit stimme ich ') }} <a class="underline text-primary font-bold" target="_blank" :href="editableProject.AGBLink ? editableProject.AGBLink : 'https://www.ev-angel-isch.de/wp-content/uploads/2024/11/AGB-ev-angel-isch2024.pdf'">{{ $t('den AGB') }}</a> {{ $t('zu.') }}</label>
          </div>
          <div class="pr-2">
            <input
              id="Datenschutz"
              type="checkbox"
              v-model="editableContract.Datenschutz"
              placeholder="Datenschutz"
            />
            <label for="Datenschutz">{{ $t('*Mit der Speicherung meiner Daten bin ich einverstanden. ev-angel-isch gemeinnützige GmbH verpflichtet sich, sie nicht an Dritte weiter zu geben und sie ausschließlich zur Verwaltung der Teilnahme an diesem Projekt zu nutzen.') }}</label>
          </div>
          <div class="pr-2">
            <input
              id="SEPAMandat"
              type="checkbox"
              v-model="editableContract.SEPAMandat"
              placeholder="SEPAMandat"
            />
            <label for="SEPAMandat">{{ $t('*Ich ermächtige / Wir ermächtigen den Zahlungsempfänger ev-angel-isch gGmbH Zahlungen von meinem / unserem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein / weisen wir unser Kreditinstitut an, die vom Zahlungsempfänger ev-angel-isch gGmbH auf mein / unser Konto gezogenen Lastschriften einzulösen.') }}</label>
          </div>
          <div v-if="editableProject.ZustimmungFoto" class="pr-2">
            <input
              id="Fotoerklärung"
              type="checkbox"
              v-model="editableContract.Fotoerklaerung"
              placeholder="Fotoerklärung"
            />
            <label for="Fotoerklärung">{{ $t('Das Team beabsichtigt Personenabbildungen: - Zur Verwendung in regionalen Presse- und Medienerzeugnissen im Rahmen des Projekts - Zur Verwendung im Internet auf der Homepage www.ev-angel-isch.de, - Zur Verwendung in Sponsorenmappen in den künftigen Jahren. Personenabbildungen in diesem Sinne sind Fotos, Grafiken, Zeichnungen oder Videoveröffentlichungen auf denen Personen individuell erkennbar sind. Hiermit willige/n ich/wir in die Anfertigung von Personenabbildungen ein. Darüber hinaus willige/n ich/wir in die oben genannte Verwendung der Personenabbildungen ohne weitere Genehmigung ein. Die Einräumung der Rechte erfolgt ohne Vergütung und umfasst auch das Recht zur Bearbeitung, soweit diese nicht entstellend werden. Im Falle des Widerrufs dürfen Einzelabbildungen zukünftig nicht mehr verwendet werden. Soweit die Einwilligung nicht widerrufen wird, gilt sie zeitlich unbeschränkt. Die Einwilligung ist freiwillig; aus der Verweigerung der Einwilligung oder ihrem Widerruf entstehen keine Nachteile.') }}</label>
          </div>
        </div>
        <div class="w-full text-center">
          <div class="text-left" v-if="bookhintVisible">
            <span class="text-xl text-red-600 font-bold whitespace-pre">{{
              editableProject.Buchungshinweis
            }}</span>
          </div>
          <button
            v-if="!editableContract.id && !loading"
            class="full-red mt-4"
            @click="bookProject()"
          >
            {{ $t('Jetzt kostenpflichtig buchen!') }}
          </button>
          <div v-if="loading" class="p-5 bg-red-500 inline-block relative">
            <div class="lds-dual-ring"></div>
          </div>
          <button
            v-if="editableContract.active"
            @click="changeContractDetails()"
            class="ml-2"
          >
            {{ $t('Angaben per Mail ändern') }}
          </button>
          <button
            v-if="
              editableContract.active &&
              editableProject.KuendigungMoeglich &&
              ['Eingegangen', 'Bestätigt', 'Warteliste', 'Vorgemerkt'].includes(
                editableContract.Status
              )
            "
            class="full-red mt-4"
            @click="checkCancelContract()"
          >
            <span v-if="editableContract.revokable">{{ $t('Vertrag widerrufen') }}</span
            ><span v-else-if="editableContract.cancellable">{{ $t('Vertrag kündigen') }}</span>
          </button>
        </div>
      </div>
      <div v-else class="w-full text-center">
        <span class="font-bold w-full text-xl text-left text-red-500 my-4 inline-block">
          {{ $t('Vor einer Vertragsbuchung müssen Sie sich zuerst einloggen, damit die persönlichen Daten abgerufen werden können.') }}</span>
          <button @click="rerouteToLogin" class="full">{{ $t('Anmelden') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import API from "@/API";

export default {
  watch: {
    customerdata: {
      handler(newVal) {
        if (newVal && !newVal.ProfilKomplett) this.$emit("close");
      },
      immediate: false,
    },
  },
  emits: ["toast", "close"],
  props: {
    currentProject: Object,
    currentContract: Object,
    customerdata: Object,
    readonly: Boolean,
    user: Object,
  },

  data() {
    return {
      editableContract: {},
      editableProject: {},
      changeDayFields: false,
      earliestChangeDate: "",
      showCancelPopup: false,
      showRevokePopup: false,
      askedForPhoto: false,
      loading: false,
      bookhintVisible: false,
      frontend: process.env.VUE_APP_EVLINE_URL,
      days: 0,
      window:window
    };
  },
  methods: {
    rerouteToLogin() {
      const url = new URL(window.location.href);
      document.cookie = `returnTo=${encodeURIComponent(url.pathname + url.search)};path=/`;
      window.location = '/login';
    },
    changeContractDetails() {
      let cc = "";
      if (this.editableContract.changeContractAddress) {
        cc = "cc=" + this.editableContract.changeContractAddress + "&";
      }
      window.open(
        "mailto:" +
          this.editableContract.contactmail +
          "?" +
          cc +
          "subject=Änderung an Vertrag " +
          this.editableContract.id,
        "_blank"
      );
    },
    cancelContract() {
      API.cancelContract(this.editableContract.id, (r, status) => {
        if (status === 200) {
          if (r.description) {
            this.$emit("toast", r.description, "success");
          } else {
            this.$emit("toast", "{{ $t('Vertrag kündigen') }}", "success");
          }
          this.$emit("close");
        } else if (r.error) {
          this.$emit("toast", r.error, "error");
        } else {
          this.$emit("toast", "{{ $t('Vertrag konnte nicht gekündigt werden') }}", "error");
        }
        this.showCancelPopup = false;
      });
    },
    checkCancelContract() {
      if (this.editableProject.KuendigungMoeglich) {
        if (this.editableContract.revokable) {
          this.scrollToTop(() => {
            this.showRevokePopup = true;
          });
        } else if (this.editableContract.cancellable) {
          this.scrollToTop(() => {
            this.showCancelPopup = true;
          });
        } else {
          this.$emit(
            "toast",
            "{{ $t('Vertrag kann nicht gekündigt werden. Der letztmögliche Zeitpunkt war der {date}.') }}",
            false
          );
        }
      }
    },
    scrollToTop(runAfter) {
      this.$refs.popup.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(runAfter, 1000);
    },
    changeDays() {
      if (this.days >= this.editableContract.InitialeAnzahlTage - 1) {
        API.updateContract(this.editableContract, (r, status) => {
          if (status == 200) {
            this.$emit("toast", this.$t('Vertrag erfolgreich angepasst'), "success");
            this.$emit("close");
          }else if(status == 400){
            this.$emit("toast", r.error, "error");
          }
        });
      }
    },
    calculateCost(change = false) {
      if (this.editableProject.Preisauswahl) {
        this.days = 0;
        ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag"].forEach(
          (day) => {
            if (change) day = "Aenderung" + day;
            if (this.editableContract[day]) this.days++;
          }
        );
        if (this.days == 0) this.days++;
        if (change) {
          this.editableContract.KostenNeu =
            this.editableProject["Preisauswahl" + this.days];
        } else {
          this.editableContract.Kosten =
            this.editableProject["Preisauswahl" + this.days];
        }
      }
    },
    handleFileChange(event, type) {
      this.file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        this.editableContract[type + "file"] = event.target.result;
        this.editableContract[type + "filename"] = this.file.name;
        if (this.editableContract.id) {
          API.uploadContractDocument(
            this.editableContract.id,
            this.file.name,
            event.target.result,
            this.editableContract.uploadDocumentType,
            (r, status) => {
              if (status === 200) {
                this.$emit("toast", this.$t('Dokument hochgeladen'), "success");
              }
            }
          );
        }
      };
      reader.readAsDataURL(this.file);
    },
    changePriceForBut() {
      if (this.editableContract.BUTBerechtigt) {
        if (this.editableProject.ButKosten) {
          this.editableContract.Kosten = this.editableProject.ButKosten;
        } else {
          this.editableContract.Kosten = "0,00 €";
        }
      } else {
        this.calculateCost();
      }
    },
    bookProject() {
      if (
        this.editableProject.ZustimmungFoto &&
        !this.editableContract.Fotoerklaerung &&
        !this.askedForPhoto
      ) {
        this.askedForPhoto = true;
        this.$emit(
          "toast",
          this.$t('Sie würden uns sehr helfen, wenn Sie uns die Zustimmung für Personenabbildungen geben würden. Andernfalls speichern Sie einfach erneut.'),
          "warning"
        );
        return;
      }
      if (
        this.editableProject.Buchungshinweis &&
        this.editableProject.Buchungshinweis != "" &&
        !this.bookhintVisible
      ) {
        this.bookhintVisible = true;
        return;
      }
      this.loading = true;
      API.bookProject(
        this.editableProject.id,
        this.editableContract,
        (r, status) => {
          this.loading = false;
          if (status === 200) {
            if (r.description) {
              this.$emit("toast", r.description, "success");
            } else {
              this.$emit("toast", this.$t('Buchung erfolgreich'), "success");
            }
            this.$emit("close");
          } else if (r.error) {
            this.$emit("toast", r.error, "error");
          }
        }
      );
    },
    initPricing() {
      if (this.editableContract.id) {
        if (
          this.editableProject.Preisauswahl &&
          !this.editableProject.Tagesauswahl
        ) {
          this.editableContract.Kosten = [
            this.editableProject.Preisauswahl1,
            this.editableProject.Preisauswahl2,
            this.editableProject.Preisauswahl3,
            this.editableProject.Preisauswahl4,
            this.editableProject.Preisauswahl5,
          ].filter((x) => x.includes(this.editableContract.Kosten))[0];
        }
        
      } else {
        if (this.editableProject.FreifeldAnzeigen) {
          this.editableContract.Freifeld = this.editableProject.Freifeldoption1;
        }
        if (
          this.editableProject.Preisauswahl &&
          !this.editableProject.Tagesauswahl
        ) {
          this.editableContract.Kosten = this.editableProject.Preisauswahl1;
        } else {
          this.editableContract.Kosten = this.editableProject.Kosten;
        }
        if (this.editableProject.Betreuungsendeoptionen.split(",").length > 1) {
          this.editableContract.Betreuungsende =
            this.editableProject.Betreuungsendeoptionen.split(",")[0];
        }
      }
      if (this.readonly) {
        setTimeout(() => {
          this.$refs.popup
            .querySelectorAll("input, textarea, select")
            .forEach((input) => {
              if (
                input.type !== "file" &&
                !input.id.includes("UploadDoc") &&
                !input.id.includes("BUTNachreichen") &&
                !input.id.includes("changeDays") &&
                !input.id.includes("Aenderung")
              ) {
                input.disabled = true;
              }
            });
        }, 150);
      }
    },
  },
  mounted() {
    if(this.customerdata && this.customerdata.id && !this.customerdata.ProfilKomplett) this.$emit("close")
    let date = new Date();
    date.setDate(date.getDate() + 14);
    date.setMonth(date.getMonth() + 1);
    date.setDate(1);
    this.earliestChangeDate = date;
    if (this.currentContract) {
      this.editableContract = this.currentContract;
      if (this.editableContract.AenderungTage) {
        this.editableContract.AenderungTage =
          this.editableContract.AenderungTage.substring(0, 7);
      }
      else{
        this.editableContract.AenderungTage = date.toISOString().substring(0, 7);
      }
    } else {
      this.editableContract = {
        Geschlecht: "",
        Betreuungsende: "",
        Ausweistyp: "",
      };
    }
    if (this.currentProject) {
      this.editableProject = this.currentProject;
      this.initPricing();
    } else if (this.editableContract.Projekt) {
      API.getBookableProject(this.editableContract.Projekt, (r, status) => {
        if (status === 200) {
          this.editableProject = r;
          this.initPricing();
        }
      });
    }
  },
};
</script>
